const footerData = {
  brand: {
    name: "Hermanos Jota",
    showroomTitle: "Showroom y Taller",
    logoAlt: "Hermanos Jota",
    logo: "/logo.svg", 
  },
  location:{
     headline: "Hermanos Jota — Casa Taller",
    addressHtml:
      "Av. San Juan 2847<br/>C1232AAB — Barrio de San Cristóbal<br/>Ciudad Autónoma de Buenos Aires<br/>Argentina",
    hoursHtml:
      "<strong>Horarios:</strong><br/>Lunes a Viernes: 10:00 - 19:00<br/>Sábados: 10:00 - 14:00",
  },
  digital: [
     {
      label: "Sitio web",
      href: "https://www.hermanosjota.com.ar",
      text: "www.hermanosjota.com.ar",
      external: true,
    },
    {
      label: "Email general",
      href: "mailto:info@hermanosjota.com.ar",
      text: "info@hermanosjota.com.ar",
    },
    {
      label: "Ventas",
      href: "mailto:ventas@hermanosjota.com.ar",
      text: "ventas@hermanosjota.com.ar",
    },
    {
      label: "Instagram",
      href: "https://instagram.com/hermanosjota_ba",
      text: "@hermanosjota_ba",
      external: true,
    },
    {
      label: "WhatsApp",
      href: "https://wa.me/541145678900",
      text: "+54 11 4567-8900",
      external: true,
    },
  ],
  legalSuffix: "Este manual es propiedad de Hermanos Jota Muebles.",
};

export default footerData;
